import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppSigma = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 34,
	height: 30,
	viewBox: "0 0 34 30",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4523 14.5191L0 0L21.4587 6.94662L14.4523 14.5191Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.2997 15.3573L26.9131 29.7913L22.2956 7.77279L15.2997 15.3573Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.4971 29.9178L9.08954 22.7067L19.6969 22.7102L25.4971 29.9178Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.84 0.155518L22.4184 6.02262L17.1924 4.32782L27.84 0.155518Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.9213 3.81618L28.9927 0.658714L34.2844 3.96813L25.9213 3.81618Z",
			fill: "white"
		})
	]
});
export default SvgAppSigma;
